import React, { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { LineBreakText } from '../Text/LineBreakText';

type Props = {
  title: string;
  value: string;
  mt?: number;
  ml?: number;
  mb?: number;
};

export const SubtitleAndDisplayBox: FC<Props> = (props) => {
  const { value, title, mt = 5, ml = 4, mb = 2 } = props;
  return (
    <Box mt={mt} ml={ml}>
      <Box mb={mb} fontSize={'xs'} color={'gray.500'}>
        {title}
      </Box>
      {/* <Box mb={mb}>{value.replace('\\n', '')}</Box> */}
      <Box mb={mb}>
        <LineBreakText fontsize="md" text={value}></LineBreakText>
      </Box>
    </Box>
  );
};
